// extracted by mini-css-extract-plugin
export default {"bulletList":"oi8DEaJ0X7cGdXRtA8r8","bulletItem":"aDJR7hg3izym7azWOMrb","paragraph":"mJy29vkoVWl3DG87Nbuw"};